export default __webpack_public_path__ + "static/media/general-failure_icon.91f635bd.png";